const styles = {
  modalWrapper: {
    position: 'fixed',
    inset: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  modalCard: {
    position: 'relative',
    width: 450,
    borderRadius: 10,
    backgroundColor: '#F6F5EE',
  },
  header: {
    position: 'absolute',
    top: -16,
    right: 0,
    zIndex: 10,
    padding: '0 8px',
  },
  closeButton: {
    padding: 8,
    backgroundColor: '#A9A9A9',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:hover': {
      backgroundColor: '#D5D5D5',
    },
  },
  infoImage: {
    width: 380,
  },
  modalContent: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 12,
    gap: '32px',
    padding: '24px',
  },
  legendMainContainer: {
    alignItems: 'flex-start',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  legendTitle: {
    fontWeight: 700,
    fontStyle: 'bold',
    fontSize: 18,
    lineHeight: '12px',
    letterSpacing: '-2%',
    marginBottom: 13,
    color: '#111110',
    textTransform: 'uppercase',
  },
  legendContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  legendRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 9,
  },
  legendIndex: {
    display: 'flex',
    width: 24,
    height: 24,
    padding: 9,
    justifyContent: 'center',
    alignItems: 'center',
    gap: 4,
    borderRadius: '50%',
    border: '1px solid #D9A600',
    background: '#FFF',
    '& span': {
      color: '#D9A600',
      textAlign: 'center',
      fontSize: 16,
      fontWeight: 800,
      lineHeight: 9,
      letterSpacing: '-0.24px',
    },
  },
  legend: {
    color: '#111110',
    fontSize: 16,
    fontWeight: 500,
    lineHeight: '12px',
    letterSpacing: '-0.24px',
  },
};

export default styles;
